import { Button, Typography } from '@mui/material';
import { FunctionComponent } from 'react';
import { useNavigate } from 'react-router-dom';
import { GameLogoScreenLayout } from '../../components/game/GameLogoLayout';
import { useKeyPress } from '../../util/Keyboard';
import { muiStyleSheet } from '../../util/Styles';

export const GameWelcomeScreen: FunctionComponent = () => {
	const navigate = useNavigate();

	useKeyPress(' ', startGame);

	function startGame() {
		void navigate('/game');
	}

	return <GameLogoScreenLayout title='Welcome'>
		<Button variant="contained" size="large"
			onClick={startGame}
			sx={styles.startButton}
		>
			<Typography variant='h4'>Let&apos;s play!</Typography>
		</Button>
	</GameLogoScreenLayout>;
};

const styles = muiStyleSheet({
	startButton: {
		position: 'absolute',
		bottom: '32px',
		left: '50%',
		paddingY: 2,
		transform: 'translateX(-50%)',
	},
});

